import type { Article } from "@/mocks/articles";

export function categoryPath(category: Article["category"]): string {
  if (category === "news") return "/news";
  if (category === "lifestyle") return "/lifestyle";
  return "/trend";
}

export function formatDate(date: string): string {
  const parts = date.split("-");
  if (parts.length !== 3) return date;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function formatShortDate(date: string): string {
  return date.replace(/-/g, ".");
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  if (views >= 1000) return `${(views / 1000).toFixed(1)}k`;
  return String(views);
}

export function getArticleById(articles: Article[], id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}